/**
 * © 2022 Patrick Lammers & Dirk Lammers
 */

/**
 * rights enumeration
 */
export enum Rights {
  READ = 1,
  CREATE = 2,
  MODIFY = 4,
  DELETE = 8,
  RESTORE = 16,
  GRANT_READ = 32,
  GRANT_CREATE_MODIFY = 64,
  GRANT_DELETE_RESTORE = 128,
}
